import React, { useEffect, useState } from 'react';
import { Button } from './ui/Button';
import { Menu, X } from 'lucide-react';
const BEEHIIV_URL = 'https://theproductivityblueprint.beehiiv.com';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSubscribe = () => {
    const element = document.getElementById('subscribe-section');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
      setIsMobileMenuOpen(false);
    }
  };
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-brand-navy/95 backdrop-blur-sm shadow-md py-3' : 'bg-brand-navy py-5'}`} data-id="element-175">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-176">
        <div className="flex justify-between items-center" data-id="element-177">
          {/* Logo */}
          <div className="flex items-center" data-id="element-178">
            <a href="#" className="flex items-center gap-2 group" data-id="element-179">
              <span className="text-white font-serif font-bold text-xl tracking-wide" data-id="element-180">
                The Productivity Blueprint
              </span>
            </a>
          </div>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8" data-id="element-181">
            <a href="#featured" className="text-gray-300 hover:text-brand-gold transition-colors text-sm font-medium" data-id="element-182">
              Archive
            </a>
            <Button variant="secondary" size="sm" onClick={() => window.open(BEEHIIV_URL, '_blank', 'noopener,noreferrer')} data-id="element-183">
              Subscribe
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden" data-id="element-184">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-white p-2 hover:bg-white/10 rounded-md transition-colors" aria-label="Toggle menu" data-id="element-185">
              {isMobileMenuOpen ? <X size={24} data-id="element-186" /> : <Menu size={24} data-id="element-187" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-brand-navy border-t border-white/10 shadow-xl p-4 flex flex-col gap-4 animate-fade-in" data-id="element-188">
          <a href="#featured" className="text-gray-300 hover:text-white py-2 block" onClick={() => setIsMobileMenuOpen(false)} data-id="element-189">
            Archive
          </a>
          <Button variant="secondary" fullWidth onClick={() => window.open(BEEHIIV_URL, '_blank', 'noopener,noreferrer')} data-id="element-190">
            Subscribe
          </Button>
        </div>}
    </nav>;
}